/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Print_Packing_Slip_TooltipInputs */

const vi_print_packing_slip_tooltip = /** @type {(inputs: Print_Packing_Slip_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tải phiếu đóng gói (PDF)`)
};

/**

* @param {Print_Packing_Slip_TooltipInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const print_packing_slip_tooltip = /** @type {((inputs?: Print_Packing_Slip_TooltipInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Print_Packing_Slip_TooltipInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_print_packing_slip_tooltip(inputs)
});